import { useEffect } from 'react';

// Tracks nested modal count so the lock stacks correctly when >1 modal is open.
let _lockCount = 0;
let _savedWinY = 0;

function getScrollEl() {
  return document.querySelector('.page-content');
}

/* Bloquea el scroll del fondo mientras una capa con fondo opaco esté abierta,
   y restaura la POSICIÓN EXACTA al cerrar (regla global, Miguel 2026-07-23).
   CAUSA REAL (tercer intento, reproducida en headless antes de tocar): el
   scroller de desktop es <html> (documentElement) — nuestro CSS global pone
   `html { overflow-x: hidden !important }` y por spec eso ANULA la propagación
   body→viewport, así que `body { overflow: hidden }` (fix F3.6) no detenía
   nada. Se congela documentElement.overflowY (+ body como cinturón) y
   .page-content (el scroller de móvil). */
export default function useScrollLock(active = true) {
  useEffect(() => {
    if (!active) return;

    _lockCount++;
    const el = getScrollEl();

    if (_lockCount === 1) {
      _savedWinY = window.scrollY;
      const scrollbar = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.overflowY = 'hidden'; // el scroller REAL de desktop
      document.body.style.overflow = 'hidden';
      if (scrollbar > 0) document.body.style.paddingRight = `${scrollbar}px`;

      if (el) {
        el.dataset.scrollLockTop = String(el.scrollTop);
        el.style.overflow = 'hidden';
        // iOS: prevent touch-based momentum scroll from leaking through.
        el.style.touchAction = 'none';
      }
    }

    return () => {
      _lockCount = Math.max(0, _lockCount - 1);
      if (_lockCount === 0) {
        document.documentElement.style.overflowY = '';
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        window.scrollTo(0, _savedWinY);
        if (el) {
          el.style.overflow = '';
          el.style.touchAction = '';
          const savedTop = parseFloat(el.dataset.scrollLockTop || '0');
          delete el.dataset.scrollLockTop;
          el.scrollTop = savedTop;
        }
      }
    };
  }, [active]);
}
